import React from "react";
import dynamic from "next/dynamic";
import Image from "next/future/image";
import { FormattedMessage } from "react-intl";
import { useRouter } from "next/router";
import styles from "./ContactUsPage.module.scss";

const Footer = dynamic(() => import("src/components/shared/Footer/Footer"));
const InfoWithIcon = dynamic(
  () => import("src/components/ContacUsPage/InfoWithIcon/InfoWithIcon"),
);
const Form = dynamic(() => import("src/components/ContacUsPage/Form/Form"));
const PageHeader = dynamic(
  () => import("src/components/shared/PageHeader/PageHeader"),
);

import ContactMap from "src/components/ContacUsPage/Map/Map";
import LocationIcon from "../../assets/images/mingcute_location-fill.png";
import PhoneIcon from "../../assets/images/trending_down.png";
import EmailIcon from "../../assets/images/ic_round-email.png";
import ClockIcon from "../../assets/images/Group.png";
import { Col, Container, Row } from "react-bootstrap";
import CommonQuestions from "src/components/shared/CommonQuestions/CommonQuestions";
import BreadCrumb from "src/components/shared/breadCrumb/Index";

const ContactUsPage = ({ data, footerData }) => {
  const router = useRouter();
  const { locale: lang } = router;
  const footer = footerData || {};

  const questionsData = data?.questions?.[0]?.categories?.[0]?.posts;

  const targetQuestion = questionsData?.find((question) => question.id === 608);
  const commonQuestionsBackgroundImage = targetQuestion?.data?.image;
  const filteredQuestions = questionsData?.filter(
    (question) => question.id !== 608,
  );
  return (
    <>
      <PageHeader />
      <BreadCrumb title={<FormattedMessage id="contact-us" />} />
      <div className={styles.background}>
        <Container>
          {footer?.AppSetting?.ifameMap && (
            <div className={styles["contact-map"]}>
              <ContactMap data={footer} />
            </div>
          )}

          <div className={styles.form}>
            <Row
              className={`${styles["contact-row"]} ${
                !footer?.AppSetting?.ifameMap ? styles["contact-row-no-map"] : ""
              }`}
              dir={lang === "ar" ? "rtl" : "ltr"}
            >
              <Col lg={8} xs={12} className={styles["form-col"]}>
                <Form />
              </Col>

              <Col lg={4} xs={12} className={styles["info-col"]}>
                <div className={styles["info-list"]}>
                  <div className={styles["info-item"]}>
                    <InfoWithIcon
                      svgIcon={
                        <Image
                          src={LocationIcon}
                          alt="location"
                          width={20}
                          height={20}
                        />
                      }
                      primaryText={<FormattedMessage id="location" />}
                      secondaryText={
                        lang === "ar"
                          ? footer?.socials?.address
                          : footer?.socials?.address_EN
                      }
                    />
                  </div>
                  <div
                    className={`${styles["info-item"]} ${styles["info-item-light"]}`}
                  >
                    <a
                      className={styles["info-link"]}
                      href={`tel:${footer?.socials?.phone
                        ?.split(" ")
                        .join("")}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <InfoWithIcon
                        svgIcon={
                          <Image
                            src={PhoneIcon}
                            alt="phone"
                            width={20}
                            height={20}
                          />
                        }
                        primaryText={<FormattedMessage id="phone" />}
                        secondaryText={footer?.socials?.phone}
                      />
                    </a>
                  </div>
                  <div className={styles["info-item"]}>
                    <a
                      className={styles["info-link"]}
                      href={`mailto:${footer?.socials?.email}`}
                    >
                      <InfoWithIcon
                        svgIcon={
                          <Image
                            src={EmailIcon}
                            alt="email"
                            width={20}
                            height={20}
                          />
                        }
                        primaryText={<FormattedMessage id="mail" />}
                        secondaryText={footer?.socials?.email}
                      />
                    </a>
                  </div>
                  <div
                    className={`${styles["info-item"]} ${styles["info-item-light"]}`}
                  >
                    <InfoWithIcon
                      svgIcon={
                        <Image
                          src={ClockIcon}
                          alt="work-time"
                          width={20}
                          height={20}
                        />
                      }
                      primaryText={<FormattedMessage id="work_time" />}
                      secondaryText={footer?.AppSetting?.work_time}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <CommonQuestions
        commonQuestionsBackgroundImage={commonQuestionsBackgroundImage}
        filteredQuestions={filteredQuestions}
      />
      <Footer />
    </>
  );
};

export default ContactUsPage;
